module.exports = __webpack_public_path__ + "img/31.250bb720.svg";